import { render, staticRenderFns } from "./ShopRequest.vue?vue&type=template&id=213093fb&scoped=true"
import script from "./ShopRequest.vue?vue&type=script&lang=js"
export * from "./ShopRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "213093fb",
  null
  
)

export default component.exports